<template>
    <div class="bookCase-view">
        <div class="bookCase-header">
            <p v-for="(item,index) in resourcesType"
               :key="index"
               :class="{'checked-type': checkedTypeIndex === index }"
               @click="changeCheckedType(item,index)">
                {{ langTransfer(item.text) }}
                <i :style="{background: themeColor}"/>
            </p>
        </div>
        <div ref="bookCaseBodyWarpper" class="bookCase-body-warpper">
            <div class="bookCase-body">
                <div v-if="bookCaseData.Data" class="bookCase-list">
                    <template v-if="resourcesType[checkedTypeIndex].text === '音频' || resourcesType[checkedTypeIndex].text === '视频'">
                        <div v-for="(item,index) in bookCaseData.Data"
                             :key="index"
                             class="bookCase-item audio-item">
                            <img :src="item.__cover" @click="goDetail(item)">
                            <p @click="goDetail(item)">{{ item.Name }}</p>
                            <span @click="goDetail(item)">{{ item.__bottomInfo }}</span>
                            <div class="play-icon" @click="goDetail(item)"/>
                        </div>
                        <div class="bookCase-item" style="height: 0;"/>
                        <div class="bookCase-item" style="height: 0;"/>
                        <div class="bookCase-item" style="height: 0;"/>
                    </template>
                    <template v-else>
                        <div v-for="(item,index) in bookCaseData.Data"
                             :key="index"
                             class="bookCase-item">
                            <img :src="item.__cover" @click="goDetail(item)">
                            <p @click="goDetail(item)">{{ item.Name }}</p>
                            <span @click="goDetail(item)">{{ item.__midInfo }}</span>
                        </div>
                        <div class="bookCase-item" style="height: 0;"/>
                        <div class="bookCase-item" style="height: 0;"/>
                        <div class="bookCase-item" style="height: 0;"/>
                    </template>
                </div>
                <div class="site-footer">
                    <Footer/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import BScroll from 'better-scroll'
    import Footer from '@/components/footer'
    export default {
        components: {
            Footer
        },
        props: {
        },
        data () {
            return {
                bookCaseBScroll: null,
                checkedTypeIndex: 0,
                resourcesTypeMap: {
                    magazine: {
                        text: '期刊',
                        resourceName: 'magazine'
                    },
                    book: {
                        text: '图书',
                        resourceName: 'book'
                    },
                    newspaper: {
                        text: '报纸',
                        resourceName: 'newspaper'
                    },
                    audio: {
                        text: '音频',
                        resourceName: 'audio'
                    },
                    video: {
                        text: '视频',
                        resourceName: 'video'
                    }
                },
                bookCaseData: [],
                dataPageIndex: 1
            }
        },
        computed: {
            userInfos () {
                return this.$store.state.userInfos
            },
            themeColor () {
                return this.$store.state.themeColor
            },
            resourcesType () {
                const { globalNavsData } = this.$store.state
                const arr = []
                globalNavsData.forEach((e) => {
                    if (this.resourcesTypeMap[e]) {
                        arr.push(this.resourcesTypeMap[e])
                    }
                })
                if (arr.length > 0) {
                    this.$nextTick(() => {
                        this.getBookcaseLists()
                    })
                }
                return arr
            }
        },
        mounted () {
            this.initBScroll()
        },
        methods: {
            initBScroll () {
                this.$nextTick(() => {
                    this.bookCaseBScroll = new BScroll(this.$refs.bookCaseBodyWarpper, {
                        bounce: false,
                        click: true,
                        pullUpLoad: {
                            threshold: 150
                        },
                        mouseWheel: {
                            speed: 20,
                            invert: false,
                            easeTime: 300
                        }
                    })
                    this.bookCaseBScroll.on('pullingUp', () => {
                        try {
                            this.pullingUpHandler()
                        } catch (error) {
                            console.log(error)
                        }
                    })
                })
            },
            changeCheckedType (item, index) {
                if (this.checkedTypeIndex === index) {
                    return
                }
                this.checkedTypeIndex = index
                this.bookCaseData = []
                this.dataPageIndex = 1
                this.getBookcaseLists()
            },
            pullingUpHandler () {
                const { ItemCount, Data } = this.bookCaseData
                if (Data.length < ItemCount) {
                    this.dataPageIndex += 1
                    this.getBookcaseLists()
                }
            },
            async getBookcaseLists () {
                try {
                    const { checkedTypeIndex, resourcesType, dataPageIndex } = this
                    const { resourceName } = resourcesType[checkedTypeIndex]
                    const data = await this.$apis('user').getBookCaseLists(resourceName, dataPageIndex)
                    if (resourceName === 'magazine') {
                        data.Data = this.$tools.formatMagazineData(data.Data)
                    }
                    if (resourceName === 'book') {
                        data.Data = this.$tools.formatBookData(data.Data)
                    }
                    if (resourceName === 'audio') {
                        data.Data = this.$tools.formatAudioData(data.Data)
                    }
                    if (resourceName === 'newspaper') {
                        data.Data = this.$tools.formatNewspaperData(data.Data)
                    }
                    if (resourceName === 'video') {
                        data.Data = this.$tools.formatVideoData(data.Data)
                    }
                    if (dataPageIndex !== 1) {
                        data.Data = this.bookCaseData.Data.concat(data.Data)
                        this.$nextTick(() => {
                            this.bookCaseBScroll.finishPullUp()
                        })
                    }
                    this.bookCaseData = data
                } catch (error) {
                    console.log(error)
                }
            },
            goDetail (item) {
                const { checkedTypeIndex, resourcesType } = this
                const { resourceName } = resourcesType[checkedTypeIndex]
                this.$tools.goDetailRoute.call(this, resourceName, item)
            }
        },
        beforeRouteEnter (to, from, next) {
            next((vm) => {
                const { userInfos } = vm.$store.state
                if (!userInfos) {
                    vm.$router.push({
                        path: '/'
                    })
                }
            })
        }
    }
</script>

<style lang="scss" scoped>
    .bookCase-view {
        width: 850px;
        position: absolute;
        top: 20px;
        left: 290px;
        bottom: 20px;
        overflow: hidden;
        background: #FFFFFF;
        box-shadow: 0 1px 3px 0 rgba(26,26,26,0.10);
        border-radius: 2px;
    }

    .bookCase-header {
        width: 850px;
        height: 50px;
        box-sizing: border-box;
        padding-left: 16px;
        background: #fff;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        border-bottom: 1px solid #F0F2F7;
        border-top-left-radius: 2px;
        border-top-right-radius: 2px;

        p {
            
            font-size: 16px;
            color: #1A1A1A;
            line-height: 50px;
            margin-right: 30px;
            position: relative;
            cursor: pointer;

             i {
                display: block;
                width: 100%;
                height: 2px;
                position: absolute;
                bottom: 5px;
                left: 0;
                background: #0084FF;
                border-radius: 1px;
                opacity: 0;
                transition: all .1s;
            }
        }

        .checked-type {

            i {
                opacity: 1;
            }
        }
    }

    .bookCase-body-warpper {
        width: 100%;
        overflow: hidden;
        position: absolute;
        top: 50px;
        left: 0;
        right: 0;
        bottom: 0;
        background: #fff;
    }

    .bookCase-body {
        position: relative;
        width: 850px;
        min-height: 100%;
        box-sizing: border-box;
        padding: 0 16px 128px;
    }

    .site-footer {
        position: absolute;
        left: 0;
        bottom: 0;
    }

    .bookCase-list {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-start;
        flex-wrap: wrap;
    }

    .bookCase-item {
        width: 150px;
        height: 248px;
        margin-top: 16px;

        img {
            display: block;
            width: 150px;
            height: 190px;
            box-shadow: 0 0px 50px 0 rgba(26,26,26,0.05);
            border-radius: 2px;
            cursor: pointer;
            background:  #f6f6f6;
        }

        p {
            width: fit-content;
            
            font-size: 16px;
            color: #1A1A1A;
            line-height: 22px;
            margin: 14px 0 8px;
            cursor: pointer;
            max-width: 150px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        span {
            display: block;
            
            font-size: 14px;
            color: #8590A6;
            line-height: 14px;
            cursor: pointer;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }

    .audio-item {
        width: 150px;
        height: 208px;
        position: relative;

        img {
            width: 150px;
            height: 150px;
        }

        .play-icon {
            cursor: pointer;
            opacity: 0;
            transition: opacity .3s;
            position: absolute;
            left: 0;
            top: 0;
            width: 150px;
            height: 150px;
            background-image: url("../../assets/homeRecommend/bgPlayIcon.png");
            background-repeat: no-repeat;
            background-position: center center;
            background-color: rgba(26,26,26,0.20);
        }

    }

    .audio-item:hover {

        .play-icon {
            opacity: 1;
        }
    }
</style>
